import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal modal--user",
  id: "modal-cropper"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = { class: "vertical-buttons" }
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-plus" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "icon-minus" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "icon-image-top" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["title"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "icon-image-bottom" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["title"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "icon-image-left" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["title"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "icon-image-right" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["title"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "icon-rotate-right" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["title"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "icon-rotate-left" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["title"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "icon-form-done" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "size-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper = _resolveComponent("cropper", true)!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "modal-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["cropper-wrapper", _ctx.modeClass])
              }, [
                _createVNode(_component_cropper, {
                  ref: "cropper",
                  class: "cropper",
                  src: _ctx.fullUrl,
                  "image-restriction": "none",
                  "stencil-props": {
                  aspectRatio: _ctx.aspectRatio,
                },
                  onChange: _ctx.change
                }, null, 8, ["src", "stencil-props", "onChange"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.zoom(1.5))),
                    title: _ctx.$t('Cropper.zoom-in'),
                    class: "square-button button button--default"
                  }, _hoisted_10, 8, _hoisted_8),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoom(0.5))),
                    title: _ctx.$t('Cropper.zoom-out'),
                    class: "square-button button button--default"
                  }, _hoisted_13, 8, _hoisted_11),
                  _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.move('top'))),
                    title: _ctx.$t('Cropper.move-top'),
                    class: "square-button button button--default"
                  }, _hoisted_16, 8, _hoisted_14),
                  _createElementVNode("div", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.move('bottom'))),
                    title: _ctx.$t('Cropper.move-bottom'),
                    class: "square-button button button--default"
                  }, _hoisted_19, 8, _hoisted_17),
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.move('left'))),
                    title: _ctx.$t('Cropper.move-left'),
                    class: "square-button button button--default"
                  }, _hoisted_22, 8, _hoisted_20),
                  _createElementVNode("div", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.move('right'))),
                    title: _ctx.$t('Cropper.move-right'),
                    class: "square-button button button--default"
                  }, _hoisted_25, 8, _hoisted_23),
                  _createElementVNode("div", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rotate(90))),
                    title: _ctx.$t('Cropper.rotate-clockwise'),
                    class: "square-button button button--default"
                  }, _hoisted_28, 8, _hoisted_26),
                  _createElementVNode("div", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.rotate(-90))),
                    title: _ctx.$t('Cropper.rotate-counter-clockwise'),
                    class: "square-button button button--default"
                  }, _hoisted_31, 8, _hoisted_29),
                  _createElementVNode("div", {
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args))),
                    title: _ctx.$t('Cropper.done'),
                    class: "square-button button button--primary"
                  }, _hoisted_34, 8, _hoisted_32)
                ]),
                (_ctx.size.width && _ctx.size.height)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('Cropper.width')) + ": " + _toDisplayString(_ctx.size.width) + "px", 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('Cropper.height')) + ": " + _toDisplayString(_ctx.size.height) + "px", 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}